/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-condition.reducer';

export const PatientConditionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientConditionEntity = useAppSelector(state => state.patientCondition.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientConditionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientCondition.detail.title">PatientCondition</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientCondition.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientCondition.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientCondition.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientCondition.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientCondition.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientCondition.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.cursor}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.patientCondition.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.startDate}</dd>
          <dt>
            <span id="startObservations">
              <Translate contentKey="tinyMedicRestApp.patientCondition.startObservations">Start Observations</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.startObservations}</dd>
          <dt>
            <span id="suspendedDate">
              <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedDate">Suspended Date</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.suspendedDate}</dd>
          <dt>
            <span id="suspendedObservations">
              <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedObservations">Suspended Observations</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.suspendedObservations}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.patientCondition.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="clinicalStatus">
              <Translate contentKey="tinyMedicRestApp.patientCondition.clinicalStatus">Clinical Status</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.clinicalStatus}</dd>
          <dt>
            <span id="verificationStatus">
              <Translate contentKey="tinyMedicRestApp.patientCondition.verificationStatus">Verification Status</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.verificationStatus}</dd>
          <dt>
            <span id="conditionCategory">
              <Translate contentKey="tinyMedicRestApp.patientCondition.conditionCategory">Condition Category</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.conditionCategory}</dd>
          <dt>
            <span id="conditionSeverity">
              <Translate contentKey="tinyMedicRestApp.patientCondition.conditionSeverity">Condition Severity</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.conditionSeverity}</dd>
          <dt>
            <span id="snomedBodySiteConceptId">
              <Translate contentKey="tinyMedicRestApp.patientCondition.snomedBodySiteConceptId">Snomed Body Site Concept Id</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.snomedBodySiteConceptId}</dd>
          <dt>
            <span id="snomedBodySiteConceptText">
              <Translate contentKey="tinyMedicRestApp.patientCondition.snomedBodySiteConceptText">Snomed Body Site Concept Text</Translate>
            </span>
          </dt>
          <dd>{patientConditionEntity.snomedBodySiteConceptText}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientCondition.chronicCondition">Chronic Condition</Translate>
          </dt>
          <dd>{patientConditionEntity.chronicCondition ? patientConditionEntity.chronicCondition.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedBy">Suspended By</Translate>
          </dt>
          <dd>{patientConditionEntity.suspendedBy ? patientConditionEntity.suspendedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientCondition.reportedBy">Reported By</Translate>
          </dt>
          <dd>{patientConditionEntity.reportedBy ? patientConditionEntity.reportedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientCondition.patient">Patient</Translate>
          </dt>
          <dd>{patientConditionEntity.patient ? patientConditionEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-condition" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-condition/${patientConditionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientConditionDetail;
